import React, { Component } from "react";

import { Page } from "./Pages";

export default class Contact extends Component {
    constructor() {
        super();
        // super(props);
        this.state = {
            loading: true,
            error: "",
            name: "how",
            title: null,
            content1: null,
            content2: null,
        };
    }

    render() {
        return (
            <section id="contactPage" className="contact-wrapper">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12">
                            <div
                                className="card mb-3 border-0"
                                style={{ maxWidth: "100%" }}
                            >
                                <div className="row no-gutters">
                                    <div className="col-md-4">
                                        <img
                                            src="/images/contact-card.png"
                                            className="card-img"
                                            alt="..."
                                        />
                                    </div>
                                    <div className="col-md-8 card-body-container">
                                        <div className="card-body text-center">
                                            <p className="card-text align-middle">
                                                <br />
                                                <br />
                                                <a
                                                    href="mailto:hello@thefreebirdclub.com"
                                                    className="font-size-16"
                                                >
                                                    hello@thefreebirdclub.com
                                                </a>
                                            </p>
                                            <p className="card-text align-middl addr">
                                                +44 (0) 3308 181 139
                                            </p>
                                            <p className="card-text align-middle addr">
                                                Freebird Club
                                                <br />
                                                Founders Factory
                                                <br />
                                                2 Arundel St
                                                <br />
                                                Temple
                                                <br />
                                                London
                                                <br />
                                                WC2R 3DA
                                                <br />
                                                <br />
                                                <br />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
